import { Component, Inject } from "@angular/core";
import { ImagePanel, ConfImageValue, Conf } from "../../../shared/models";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { PanelComponent } from "../../shared/panelComponent";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'image-panel',
  templateUrl: './imagePanelComponent.html'
})
export class ImagePanelComponent extends PanelComponent<ImagePanel> {

  public confImageValue: ConfImageValue;

  constructor(
    public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper
  ) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

  ngOnInit() {

    // Initial value on load.
    this.confImageValue = this.configuration.imageValues.find((x) => x.longId == this.panel.longId);
    super.ngOnInit();

  }

  public listenChanges(): void {
    this.confStore.onConfigurationChange(this.configurationId, this.confPageSessionService.confSessionId, (configuration: Conf): void => {
      this.confImageValue = this.configuration.imageValues.find((x) => x.longId == this.panel.longId);
    }).unsubscribeOn(this.unsubscribeSubject);
  }

}